import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { URLs } from 'src/environments/constants';

@Injectable({
  providedIn: 'root'
})
export class LlamaIndexService {
  private http = inject(HttpClient);
  private readonly baseUrl = URLs.MASTER_LIBRARY_SERVICE;

  /**
   * Envía el archivo al Backend de PDMS para que sea procesado por el motor elegido (LiteParse o LlamaIndex).
   * @param libSlug Slug de la librería actual
   * @param file Archivo obtenido de un input HTML
   * @param parserType Tipo de motor a usar ('lite' o 'llama'). Por defecto 'lite'.
   * @returns Promesa con el contenido Markdown
   */
  async parseFileToMarkdown(libSlug: string, file: File, parserType: 'lite' | 'llama' = 'lite'): Promise<string> {
    try {
      console.log(`[LlamaIndex] Enviando archivo al servidor para conversión (${parserType}): ${file.name}`);
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('parserType', parserType);

      // Llamamos a nuestro propio backend (Proxy)
      const workspace_api_url = `${this.baseUrl}/${libSlug}/ParseToMarkdown`;
      
      const result = await firstValueFrom(this.http.post<any>(workspace_api_url, formData));

      console.log(`[LlamaIndex] Conversión completada en el servidor.`);
      // En PDMS, las respuestas se envuelven en 'operation'
      return result?.operation?.markdown || result?.markdown || '';

    } catch (error) {
      console.error('[LlamaIndex] Error en la conversión remota:', error);
      throw error;
    }
  }
}
